import api from './api';
import type { Notification } from '@/types/notification';

export const notificationApi = {
  getNotifications: (limit = 20, offset = 0, signal?: AbortSignal) =>
    api.get<{ notifications: Notification[] }>('/api/notifications', {
      params: { limit, offset },
      signal,
    }),

  getUnreadCount: (signal?: AbortSignal) =>
    api.get<{ unread_count: number }>('/api/notifications/unread-count', { signal }),

  markAsRead: (id: number) =>
    api.patch<{ success: boolean }>(`/api/notifications/${id}/read`),

  markAllAsRead: () =>
    api.patch<{ success: boolean; updated: number }>('/api/notifications/read-all'),

  deleteNotification: (id: number) =>
    api.delete<{ success: boolean }>(`/api/notifications/${id}`),

  deleteAll: () =>
    api.delete<{ success: boolean; deleted: number }>('/api/notifications'),
};
